

import React, { useContext, useEffect, useState } from 'react';
import './productSummaryPage.css';
import { INSTANCE_WHITE_LOGO_URL as logo } from '../../components/ui/InstanceLogo';
import { InvoiceContext } from '../../context/invoice/InvoiceContext';
import { MenuQRContext } from '../../context/menu/MenuQRContext';
import { QrProduct } from './modifierChoice';
import ProductCard from './ProductCard';
import { Product } from '../../models/interfaces';
import ProductSummaryPage from './ConfirmOrderPage';
import { useNavigate } from "react-router-dom";
import Message from '../../components/ui/Message';

const ConfirmOrderPage: React.FC = () => {
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const { selectedProducts, addProduct, removeProduct, createOrder, merchant } = useContext(MenuQRContext);
    // menuQrOrderOnly = false: el cliente paga con tarjeta antes de que se cree la orden
    const payBeforeOrder = merchant?.menuQrOrderOnly === false;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [text, setText] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);


    const removeError = () => {
        setErrorMessage('');
    }
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        setLogoUrl(logo);
    }, []);



    const handleNext = async () => {
        if (Object.keys(selectedProducts).length === 0) {
            setErrorMessage('Debe seleccionar al menos un producto.')
            return;
        }
        if (isSubmitting) return;

        if (payBeforeOrder) {
            navigate("/menuqr/pay", { state: { detail: text } });
            return;
        }

        setIsSubmitting(true);
        const resp = await createOrder(text);
        setIsSubmitting(false);

        if (resp == "success") {
            setSuccessMessage('Su pedido fue enviado correctamente.');
        } else {
            setErrorMessage(resp);
        }
    };

    // Al cerrar el mensaje de éxito se muestra el pedido
    const goToOrder = () => {
        setSuccessMessage('');
        navigate("/menuqr/order");
    };


    return (
        <div className='wrapper1'>

            <div className="headerLogin">
                <img src={logoUrl || ''} alt="Logo" className="logo" />
            </div>

            <div className="container-voucher my-5" style={{ paddingBottom: '80px' }}>


                <div className="row">
                    <h1 style={{ textAlign: 'center' }}>Resumen de Pedido</h1>
                    <div>
                        <div className="summary-page">

                            {selectedProducts.length === 0 ? (
                                <p>No hay productos seleccionados.</p>
                            ) : (
                                <div>
                                    {
                                        selectedProducts.map(product => (
                                            <div key={product.id} className="summary-item">
                                                <div className="summary-info">
                                                    <strong>{product.name}</strong>
                                                    <p>{product.shortDescription}</p>
                                                    {(product as QrProduct).message && <p className="small text-muted mb-0">{(product as QrProduct).message}</p>}
                                                </div>
                                                <div className="quantity-control">
                                                    <button className='btn btn-danger' onClick={() => removeProduct(product)}>-</button>
                                                    <span>{product.quantity || 0}</span>
                                                    <button className='btn btn-success' onClick={() => addProduct(product)}>+</button>
                                                </div>
                                            </div>
                                        ))

                                    }

                                    <div style={{ height: '15px' }}></div>
                                    <h4>Detalles del pedido</h4>
                                    <textarea className="form-control" rows={2} placeholder="Comentarios..." value={text}
                                        onChange={(e) => setText(e.target.value)}></textarea>
                                    <div style={{ height: '15px' }}></div>
                                    {/* <p> Para llevar</p> */}

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>








            {/* Botón fijo abajo */}
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#fff',
                padding: '10px',
                boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                zIndex: 999
            }} className="d-flex justify-content-center">
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-default w-75"
                >
                    Atrás
                </button>
                <div className='me-5' />

                <button
                    type="button"
                    onClick={handleNext}
                    className="btn btn-primary w-75"
                    disabled={isSubmitting || successMessage.length > 0}
                >
                    {isSubmitting
                        ? <><span className="spinner-border spinner-border-sm me-1" /> Enviando...</>
                        : payBeforeOrder ? 'Continuar al pago' : 'Continuar'}
                </button>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} /> : ''
            }
            {
                successMessage.length > 0 && (
                    <Message
                        type='success'
                        title='Pedido enviado'
                        message={successMessage}
                        closeDialog={goToOrder}
                        handleOk={goToOrder}
                        backgroundColor='rgba(0,0,0,0.4)'
                    />
                )
            }
        </div>
    )
}


export default ConfirmOrderPage;



